const MediaViewerStyle = () => ({
  container: {
    flex: 1,
    position: 'relative',
    backgroundColor: '#F4F7F8',
  },
  mediaContainer: {
    height: 300,
    backgroundColor: '#EEF2F4',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    overflow: 'auto',

    '& img': {
      width: '100%',
      height: 'auto',
      margin: 'auto',
      display: 'inline-block',
      transition: 'transform 0.3s',
      transformOrigin: 'top',
    },
    '& iframe': {
      width: '100%',
      border: '1px solid #E2E8EB',
      borderBottom: 'none',
    },
  },
  tools: {
    position: 'absolute',
    top: 250,
    textAlign: 'center',
    width: '100%',
    height: 34,

    '& > *': {
      backgroundColor: 'rgba(31, 42, 50, 0.72)',
      color: '#FFF',
      border: 'none',
      height: '100%',
      borderRadius: 6,
      margin: '0 2px',
    },
    '& button': {
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: 'rgba(0, 168, 188, 0.9)',
      },
    },
  },
  attachment: {
    width: '100%',
    boxSizing: 'border-box',
    '& .filename': {
      width: '100%',
      maxWidth: 200,
    },
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
});

export default MediaViewerStyle;
